module.exports = __webpack_public_path__ + "static/media/whatsapp.6af811ad.svg";